import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {AppThunk} from "../store.ts";
import {IRefStatsData, IUserResponseData, IUserUpdateParams, ParamsRefStatsData} from "../models/UserResponse.ts";
import {LoginDataType, UserService} from "../services/user-service.ts";
import {AxiosError} from "axios";
import {appActions} from "./app-reducer.ts";
import {NavigateFunction} from "react-router-dom";
import {setReferralCode, setUserBalance, successToastify, unCheckAuth} from "../../utils/Utils.ts";
import {getNearestTimezoneAndSave} from "../../dateUtils/dateUtils.ts";
import {showCustomErrorToast} from "../../utils/customErrorToast.tsx";
import i18n, {t} from "i18next";

type  InitialStateType = {
    data: IUserResponseData | null
    ref_stats: IRefStatsData | null
    isLoading: boolean
    shareData: string
};

const initialState: InitialStateType = {
    data: null,
    ref_stats: null,
    isLoading: false,
    shareData: ''
}

const slice = createSlice({
    name: "user",
    initialState: initialState,
    reducers: {
        setInitialData: (state: InitialStateType, action: PayloadAction<IUserResponseData>) => {
            state.data = action.payload
        },
        setRefStatsData: (state: InitialStateType, action: PayloadAction<IRefStatsData>) => {
            state.ref_stats = action.payload
        },
        setLoading: (state, action: PayloadAction<boolean>) => {
            state.isLoading = action.payload;
        },
        setShareData: (state, action: PayloadAction<string>) => {
            state.shareData = action.payload;
        },
    },
});

export const userReducer = slice.reducer;
export const userActions = slice.actions;

export const setInitialDataTC = (navigate: NavigateFunction): AppThunk<Promise<IUserResponseData | void>> =>
    async (dispatch) => {
        try {
            const res = await UserService.fetchUserData();
            dispatch(appActions.initializeStateOfApp(true))
            dispatch(userActions.setInitialData(res.data))
            setUserBalance(res.data.balance)
            setReferralCode(res.data.referral_code)
            console.log('getNearestTimezoneAndSave')

            localStorage.setItem("user_timeZone", JSON.stringify(res.data.timezone))

            i18n.changeLanguage(res.data.language); // i18next сам сохранит в localStorage, если настроен detection.caches
            localStorage.setItem("user_id", JSON.stringify(res.data.id))
            return res.data
        } catch (err) {

            if (err instanceof AxiosError)
                showCustomErrorToast(err.message, 'main', 'bottom-center');
            unCheckAuth()
            navigate('/login');
            throw err;
        }
    };

export const setShareDataTC = (): AppThunk<Promise<string>> =>
    async (dispatch) => {
        try {
            const res = await UserService.fetchUserShareData();
            dispatch(userActions.setShareData(res.data))
            return res.data
        } catch (err) {
            if (err instanceof AxiosError)
                console.log(err)
            throw err;
        }
    };

export const setRefStatsDataTC = (params: ParamsRefStatsData): AppThunk<Promise<IRefStatsData | void>> =>
    async (dispatch) => {
        try {
            const res = await UserService.fetchRefStatsData(params);
            dispatch(userActions.setRefStatsData(res.data))
            getNearestTimezoneAndSave()
            return res.data
        } catch (err) {
            if (err instanceof AxiosError)
            showCustomErrorToast(t('modals.referralStatsFilter.state.errorResponse'), 'main', 'bottom-center')
            throw err;
        }
    };

export const updateUserDataTC = (params: IUserUpdateParams, successTitle: string, errorTitle: string): AppThunk<Promise<IUserResponseData | void>> =>
    async (dispatch) => {
        dispatch(userActions.setLoading(true));
        try {
            const res = await UserService.updateUser(params);
            dispatch(userActions.setInitialData(res.data))
            successToastify(successTitle, 'bottom-center', 'main');
            localStorage.setItem("user_timeZone", JSON.stringify(res.data.timezone))
            localStorage.setItem("user_language", JSON.stringify(res.data.language))
            return res.data
        } catch (err) {
            if (err instanceof AxiosError)
                showCustomErrorToast(errorTitle, 'main', 'bottom-center')
            throw err;
        } finally {
            dispatch(userActions.setLoading(false));
        }
    };

export const loginUserTC = (navigate: NavigateFunction, data: LoginDataType): AppThunk<Promise<IUserResponseData | void>> =>
    async (dispatch) => {
        try {
            const res = await UserService.loginUser(data);
            dispatch(appActions.initializeStateOfApp(true))
            dispatch(userActions.setInitialData(res.data))
            navigate('/');
            return res.data
        } catch (err) {
            if (err instanceof AxiosError)
                unCheckAuth()
            throw err;
        }
    };




